/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum DeploymentScheduleType {
    UpgradeNow,
    ScheduleUpgrade,
}
